import { liveItems } from "@/mocks/home";

const pill: Record<string, string> = {
  live: "bg-accent text-white",
  update: "bg-accent-soft text-accent-deep",
  check: "bg-paper-2 text-muted ring-1 ring-line",
  scene: "bg-marker/15 text-ink",
};

export default function Live() {
  return (
    <section id="live" className="mx-auto max-w-6xl scroll-mt-24 px-4 pt-16 md:px-6 md:pt-24">
      <div className="flex items-end justify-between gap-4">
        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-muted">正在发生 · Live</p>
          <h3 className="font-display mt-2 text-2xl font-bold tracking-tight text-ink md:text-3xl">
            此刻，还没汇成定论的碎片
          </h3>
        </div>
        <span className="hidden whitespace-nowrap items-center gap-2 text-sm text-muted md:inline-flex">
          <i className="ri-record-circle-line text-accent" /> 24 小时突发通道开放
        </span>
      </div>

      <div className="mt-8 divide-y divide-line border-y border-line">
        {liveItems.map((item) => (
          <a
            key={item.id}
            href="#timeline"
            className="group grid cursor-pointer items-center gap-x-6 gap-y-2 py-5 transition-colors sm:grid-cols-[72px_64px_1fr_auto]"
          >
            <span className="font-display text-lg font-semibold tabular-nums text-ink sm:text-xl">
              {item.time}
            </span>
            <span className="text-xs uppercase tracking-wider text-muted">{item.tag}</span>
            <span className="text-[15px] leading-6 text-ink/85 transition-colors group-hover:text-accent-deep">
              {item.text}
            </span>
            <span
              className={`mt-1 inline-flex w-fit items-center whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs sm:mt-0 ${pill[item.statusKind]}`}
            >
              {item.status}
            </span>
          </a>
        ))}
      </div>
    </section>
  );
}